/** Telas com campos obrigatórios configuráveis na API Produto (db_produto.tela). */
export enum TelaProdutoEnum {
    Produto = 1,
}
